import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "filterCampaignBySystem",
})
export class filterCampaignBySystemPipe implements PipeTransform {
  transform(campaigns: Array<any> = [], system: any): any {
    if(system && campaigns?.length > 0) {
      const campaignFiltered = campaigns?.filter(campaign => {
        if(
          campaign?.campaign?.resources[0] && 
          campaign?.campaign?.resources[0].systems && 
          campaign?.campaign?.resources[0].systems[0] && 
          campaign?.campaign?.resources[0].systems[0].id === system?.id) {
            return true
          } else {
            return false;
          }
      });
      return campaignFiltered;
    } else {
      return campaigns;
    }
  }
}

@Pipe({
  name: "filterTestProtocolByCampaign",
})
export class filterTestProtocolByCampaignPipe implements PipeTransform {
  transform(testProtocols: Array<any> = [], campaign: any): any {
    if(campaign && campaign?.campaign && campaign?.campaign?.resources[0] && testProtocols?.length > 0) {
      return campaign?.campaign?.resources[0].testProtocols;
    } else {
      return testProtocols;
    }
  }
}

@Pipe({
  name: "filterUsecaseByTestProtocol",
})
export class filterUsecaseByTestProtocolPipe implements PipeTransform {
  transform(usecases: Array<any> = [], testProtocol: any): any {
    if(testProtocol && usecases?.length > 0) {
      return testProtocol?.testScenarios;
    } else {
      return usecases;
    }
  }
}
